<template>
  <div class="container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/yunwei' }">运维管理</el-breadcrumb-item>
      <el-breadcrumb-item>品牌配置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="search-card">
      <div class="toolbar">
        <el-button type="primary" @click="handleAdd">添加品牌</el-button>
      </div>
    </el-card>

    <el-card>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="brand" label="品牌" width="140" />
        <el-table-column label="采集端" width="140">
          <template slot-scope="scope">
            {{ scope.row.collectorId ? scope.row.collectorId.name : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="cdpPort" label="CDP说明" width="100" align="center" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="small">
              {{ scope.row.enabled ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑弹窗 -->
    <el-dialog :title="isEdit ? '编辑品牌' : '添加品牌'" :visible.sync="dialogVisible" width="450px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="品牌名称" prop="brand">
          <el-input v-model="form.brand" placeholder="如：美滋滋" maxlength="20" />
        </el-form-item>
        <el-form-item label="所属采集端" prop="collectorId">
          <el-select v-model="form.collectorId" placeholder="请选择采集端" style="width:100%">
            <el-option v-for="c in collectors" :key="c._id" :label="c.name" :value="c._id" />
          </el-select>
        </el-form-item>
        <el-form-item label="CDP说明" prop="cdpPort">
          <el-input-number v-model="form.cdpPort" :min="1024" :max="65535" style="width:100%" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.enabled" active-text="是" inactive-text="否" />
        </el-form-item>
        <el-form-item label="独立品牌">
          <el-switch v-model="form.isStandalone" active-text="是" inactive-text="否" />
          <span style="font-size:12px;color:#909399;margin-left:8px;">独立品牌有独立采集任务和队列</span>
        </el-form-item>
        <el-form-item label="IM代管品牌">
          <el-select v-model="form.imBrands" multiple filterable allow-create default-first-option placeholder="留空=不代管其他品牌" style="width:100%">
            <el-option v-for="b in allBrandNames" :key="b" :label="b" :value="b" />
          </el-select>
          <span style="font-size:12px;color:#909399;">独立品牌可列出自身+附属品牌，推送时合并白名单</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">{{ isEdit ? '保存' : '添加' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BrandManage',
  data () {
    return {
      list: [],
      collectors: [],
      allBrandNames: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      editId: null,
      submitting: false,
      form: {
        brand: '',
        collectorId: '',
        cdpPort: 9222,
        enabled: true,
        isStandalone: true,
        imBrands: []
      },
      rules: {
        brand: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }],
        collectorId: [{ required: true, message: '请选择采集端', trigger: 'change' }],
        cdpPort: [{ required: true, message: '请输入CDP说明', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.fetchList()
    this.fetchCollectors()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('yunwei/brand/list', { params: { all: 1 } })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list || []
        this.allBrandNames = this.list.map(b => b.brand)
      } catch (e) {
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    async fetchCollectors () {
      try {
        const { data: res } = await this.$http.get('yunwei/collector/list')
        if (res.meta.status === 200) this.collectors = res.data.list || []
      } catch (e) { /* 忽略 */ }
    },
    handleAdd () {
      this.isEdit = false
      this.editId = null
      this.dialogVisible = true
    },
    handleEdit (row) {
      this.isEdit = true
      this.editId = row._id
      this.form = {
        brand: row.brand,
        collectorId: row.collectorId ? row.collectorId._id : '',
        cdpPort: row.cdpPort,
        enabled: row.enabled,
        isStandalone: row.isStandalone !== false,
        imBrands: row.imBrands || []
      }
      this.dialogVisible = true
    },
    async handleDelete (row) {
      try {
        await this.$confirm(`确定删除品牌「${row.brand}」吗？`, '提示', { type: 'warning' })
        const { data: res } = await this.$http.delete('yunwei/brand/remove', { data: { id: row._id } })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('已删除')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error('删除失败')
      }
    },
    async submitForm () {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      try {
        const payload = { ...this.form }
        let res
        if (this.isEdit) {
          payload.id = this.editId
          res = await this.$http.put('yunwei/brand/modify', payload)
        } else {
          res = await this.$http.post('yunwei/brand/add', payload)
        }
        if (res.data.meta.status !== 200) return this.$message.error(res.data.meta.msg)
        this.$message.success(this.isEdit ? '已保存' : '已添加')
        this.dialogVisible = false
        this.fetchList()
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.submitting = false
      }
    },
    resetForm () {
      this.form = {
        brand: '',
        collectorId: '',
        cdpPort: 9222,
        enabled: true,
        isStandalone: true,
        imBrands: []
      }
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style scoped>
.toolbar { margin-bottom: 0; }
</style>
